import React from 'react'
import { IntegrationEmailThread } from '../../../models/Email'
import { useLastContactEmailFromThread } from './hooks'

export interface EmailStatusCellProps {
  thread: IntegrationEmailThread
  onClick: (thread: IntegrationEmailThread) => void
}

interface StatusDisplay {
  label: string
  background: string
  primaryIcon: string
  secondaryIcon: string
  secondaryIconColor: string
  secondaryIconBgColor: string
  secondaryIconClassName?: string
}

const STATUS_MAP: { [key: string]: StatusDisplay } = {
  new: {
    label: 'New',
    background: 'zocks-bg-color-primary-light',
    primaryIcon: 'bi-envelope',
    secondaryIcon: 'bi-exclamation-circle-fill',
    secondaryIconColor: 'zocks-text-primary',
    secondaryIconBgColor: 'zocks-bg-color-white',
  },
  replyGenerated: {
    label: 'Reply generated',
    background: 'zocks-bg-color-primary-light',
    primaryIcon: 'bi-envelope',
    secondaryIcon: 'bi-stars',
    secondaryIconColor: 'zocks-text-white',
    secondaryIconBgColor: 'zocks-bg-color-primary',
    secondaryIconClassName: 'reply-generated-icon',
  },
  processed: {
    label: 'Processed',
    background: 'zocks-bg-color-success-background',
    primaryIcon: 'bi-envelope',
    secondaryIcon: 'bi-check-circle-fill',
    secondaryIconColor: 'zocks-text-success',
    secondaryIconBgColor: 'zocks-bg-color-white',
  },
}

export const EmailStatusCell: React.FC<EmailStatusCellProps> = ({ thread, onClick }) => {
  const { lastEmailByContactMetadata } = useLastContactEmailFromThread(thread)

  const status = lastEmailByContactMetadata?.processedByUser
    ? 'processed'
    : lastEmailByContactMetadata?.responseProcessing?.finishedAt && !lastEmailByContactMetadata?.responseProcessing?.noResult
      ? 'replyGenerated'
      : 'new'

  const statusDisplay = STATUS_MAP[status]
  if (!statusDisplay) {
    return null
  }

  const { label, background, primaryIcon, secondaryIcon, secondaryIconColor, secondaryIconBgColor, secondaryIconClassName } = statusDisplay

  return (
    <div className='d-flex gap-2' onClick={() => onClick(thread)}>
      <div className='d-inline-flex position-relative'>
        <i className={`bi ${primaryIcon} fs-5`} />
        <i
          className={`bi ${secondaryIcon} ${secondaryIconColor} ${secondaryIconBgColor} ${secondaryIconClassName ?? ''} status-icon-overlay d-flex align-items-center justify-content-center zocks-border-0.5`}
        />
      </div>
      <div className={`d-flex align-items-center justify-content-center py-1 px-2 zocks-border-0.25 ${background}`}>
        <span className='lead-extra-small text-nowrap'>{label}</span>
      </div>
    </div>
  )
}
